<template>
  <el-drawer
  title="Filtres"
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <el-form label-position="top">
      <el-form-item>
        <el-button @click="resetFilters()" size="mini">Remettre les filtres d'origine</el-button>
      </el-form-item>
      <el-collapse v-model="activeName">
        <el-collapse-item title="Statut" name="1">
          <el-form-item>
            <el-checkbox-group v-model="statusFilter">
              <el-row :gutter="20" v-for="status in purchaseOrderStatuses" :key="status.id">
                <el-col>
                  <el-checkbox :label="status.id">{{$t('purchase_orders.statuses.'+status.code)}}</el-checkbox>
                </el-col>
              </el-row>
            </el-checkbox-group>
         </el-form-item>
        </el-collapse-item>
        <el-collapse-item title="Date de demande" name="2">
          <el-form-item label="Intervalle">
            <el-date-picker
               v-model="dateFilter"
               type="daterange"
               range-separator="à"
               start-placeholder="Date de début"
               end-placeholder="Date de fin">
             </el-date-picker>
          </el-form-item>
          <el-form-item label="Année">
            <el-date-picker
               v-model="yearFilter"
               type="year">
             </el-date-picker>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item title="Date de réception" name="3">
          <el-form-item label="Intervalle">
            <el-date-picker
               v-model="availabilityDateFilter"
               type="daterange"
               range-separator="à"
               start-placeholder="Date de début"
               end-placeholder="Date de fin">
             </el-date-picker>
          </el-form-item>
          <el-form-item label="Année">
            <el-date-picker
               v-model="availabilityYearFilter"
               type="year">
             </el-date-picker>
          </el-form-item>
        </el-collapse-item>
      </el-collapse>
   </el-form>
  </div>
</el-drawer>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'pruchase-order-filter',
	props: {
    visible : {type : Boolean},
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    }
	},
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      activeName : null,
    };
  },components: {

  },
  watch : {

  },
	methods: {
    open(){

    },
    handleClose(){
      this.$emit('close');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ...mapActions('statuses',['fetchPurchaseOrderStatuses']),
    ...mapActions('purchaseOrders', ['setStatusFilters','resetFilters','setDateFilters','setYearFilters','setAvailabilityDateFilters','setAvailabilityYearFilters']),
	},
	computed: {
    statusFilter : {
      get(){return this.filters.status;},
      set(statusFilters){this.setStatusFilters(statusFilters)}
    },
    dateFilter : {
      get(){return this.filters.date},
      set(dateFilter){this.setDateFilters(dateFilter)}
    },
    yearFilter : {
      get(){return this.filters.year},
      set(yearFilter){this.setYearFilters(yearFilter)}
    },
    availabilityDateFilter : {
      get(){return this.filters.availabilityDate},
      set(dateFilter){this.setAvailabilityDateFilters(dateFilter)}
    },
    availabilityYearFilter : {
      get(){return this.filters.availabilityYear},
      set(yearFilter){this.setAvailabilityYearFilters(yearFilter)}
    },
		checkedCustomerClasses :{
			set(val){this.changeCustomerClassFilter(val)},
			get(){return this.filters.checkedCustomerClasses;}
		},
    invoicedFilter : {
      set(val){this.changeInvoicedFilter(val)},
      get(){return this.filters.checkedInvoiced;}
    },
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "40%";
      }else{
        return "100%"
      }
    },
    ...mapState('statuses',['purchaseOrderStatuses']),
    ...mapState('purchaseOrders',['filters'])
	},
  created(){
    this.fetchPurchaseOrderStatuses();
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

// .el-row {
//     margin-bottom: 20px;
//     &:last-child {
//       margin-bottom: 0;
//     }
//   }

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
